/**
 * Created by yangrui on 2021/4/14.
 */
'use strict';
import request from "@/api/axios";

/** v2.3.8 start **/

// 法院权限-根据法院id获取允许的保全类型和类别 /api/v1.0/permission/court/query_bqlx_bqlb
export function getQueryPermission(params) {
    return request({
        url: 'ssbq/api/permission/court/query_bqlx_bqlb',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

/** v2.3.8 end **/

// 已出函时，点击申请保全
export function creatByChuHan(params) {
    return request({
        url: 'ssbq/api/bqsq/sqbq',
        method: 'post',
        params:{
            ...params
        }
    })
}

// 一键申请保全
export function submitBqsqOneKey(params) {
    return request({
        url: 'ssbq/api/bqsq/tj',
        method: 'put',
        params:{
            time: new Date().getTime(),
            ...params
        },
    })
}

/** v2.3.8 end **/

/** 数据统计 v2.3.7 start **/
//v2.3.7 1.变更担保-验证担保是否可以变更
export function getDbbgVerify(params) {
    return request({
        url: 'commonapi/api/bgdb/verify',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

//v2.3.7 2.申请变更担保
export function reqDbbgSqbg(params) {
    return request({
        url: 'commonapi/api/bgdb/sqbg',
        method: 'post',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

//v2.3.7 3.申请变更担保-封装数据
export function getDbbgBbjbxx(params) {
    return request({
        url: 'commonapi/api/bgdb/dbjbxx/'+params,
        method: 'get',
        params: {
            time: new Date().getTime()
        }
    })
}

/** 数据统计 v2.3.7 end **/

export function getCode(params) {
    return request({
        url: 'ssbq/api/code',
        method: 'get',
        params:{
            ...params
        },
    })
}

// v2.3.5 创建开票
export function createKP(params) {
    return request({
        url: 'commonapi/api/kp/sqkp',
        method: 'post',
        params: {
            time: new Date().getTime()
        },
        data: {
            ...params
        }
    })
}

// 查看开票所需人员信息接口
export function getkpRyxx(params) {
    return request({
        url: 'commonapi/api/kp/ryxx',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

// 查看开票信息接口
export function getCxkp(params) {
    return request({
        url: 'commonapi/api/kp/cxkp',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

// v2.3.5 申请退保提示接口
export function checkTB(params) {
    return request({
        url: 'commonapi/api/tuib/sqtb/checkSurrender',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

// v2.3.5 创建退保申请
export function createTB(params) {
    return request({
        url: 'commonapi/api/tuib/sqtb',
        method: 'post',
        params: {
            time: new Date().getTime()
        },
        data: {
            ...params
        }
    })
}

// 查看退保信息接口
export function getCxtb(params) {
    return request({
        url: 'commonapi/api/tuib/cxtb',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

// 退保 上传材料_new
export function uploadTuiBao(data,fn) { //路径等待确认
    return request({
        url: 'commonapi/api/tuib/tbcl/fileupload',
        method: 'post',
        headers: {
            "Content-Type": 'multipart/form-data',
        },
        params: {
            time: new Date().getTime(),
        },
        data:data,
        onUploadProgress:fn
    })
}

// 退保 删除上传材料
export function delUploadTB(params) { //路径等待确认
    return request({
        url: 'commonapi/api/tuib/tbcl/del',
        method: 'delete',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}

export function getId(params) {
    return request({
        url: 'ssbq/api/id',
        method: 'get',
        params: {
            time: new Date().getTime(),
            ...params
        }
    })
}
